import { ACTIONS as CLIENT_ACTIONS } from '@teem/core/constants/client';
import { messages as i18n } from '@teem/core/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/core/constants/api';
export default class ClientsTableSchema {
	containerContext: any;

	keyColumn: string = 'uuid';
	serverUrl: string = `${Api.client.all}`;
	headers: Array<object> = [
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client pl-3" },
		{ "label": $localize`:@@ts.phone_number:Phone Number`, "thClass": "th-active-project" },
		{ "label": $localize`:@@ts.active_invoices:Active Invoices`, "thClass": "th-active-project" },
		{ "label": $localize`:@@ts.paid_invoices:Paid Invoices`, "thClass": "th-completed-projects" },
		{ "label": $localize`:@@ts.amount:Amount`, "thClass": "th-total-income" },
		{ "label": '', "thClass": "th-send-proposal" },
		// { "label": '', "thClass": "th-edit-client" },
	];
	cols: Array<object> = [
		{
			"key": "full_name", "tdClass": "td-client-name pl-3",
			"render": (value, row) => `<span class="bt-content"><span class="name-circule" style=background-color:${ row.color ? row.color : '' }>${value ? getAcronym(value) : ''}</span><a class="client-name">${value ? value : ''}</a></span>`,
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('client-name')) {
					this.containerContext.onTableDataClick(CLIENT_ACTIONS.EDIT, row);
				}
			}
		},
		{
			"key": "phone", "tdClass": "td-phone-number",
			"render": (value) => `${value ? value : ''}`
		},
		{ "key": "active", "tdClass": "td-active-project", "render": (value) => `${value ? value : 0}` },
		{ "key": "completed", "tdClass": "td-completed-projects", "render": (value) => `${value ? value : 0}` },
		{ 
			"key": "total_income", 
			"tdClass": "td-total-income", 
			"render": (value, row) => {
				return `<div class="amount">
              				<span class="sar">${row?.currency}</span>
							<span class="price">${value ? value : 0}</span>
						</div>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			} 
		},
		{
			"key": "uuid", "tdClass": "td-send-proposal",
			"render": (value) => `<span class="bt-content"><a href="javascript:void(0)" class="sendinvoice">` + i18n.client.send_invoice + `</a></span>`,
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('sendinvoice')) {
					this.containerContext.onTableDataClick(CLIENT_ACTIONS.SEND_INVOICE, row);
				}
			}
		},
		// {
		// 	"key": "uuid", "tdClass": "td-edit-client",
		// 	"render": (value) => `<a class="tu-btn-circular cursor-pointer transparent edit-client-btn"><i class="edit-icon"></i></a>`,
		// 	"dataClick": (e, value?: any, row?: any) => {
		// 		if (e.target.classList.contains('edit-client-btn') || e.target.classList.contains('edit-icon')) {
		// 			this.containerContext.onTableDataClick(CLIENT_ACTIONS.EDIT, row);
		// 		}
		// 	}
		// }

	];

	constructor(container: any) {
		this.containerContext = container;
	}

  newColor() {
    return setTimeout(() => {
      let letters = 'BCDEF'.split('');
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)];
      }
      return color;
    }, 200);
  }
}
